// extracted by mini-css-extract-plugin
export default {"wrap":"Spinner_wrap__w653m","spinner":"Spinner_spinner__Z6H3Z","spin":"Spinner_spin__Q9zsz","timer":"Spinner_timer__e1P+h"};